/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Invoice/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import Tysiav2LedgerFilterInvoices from 'DesignSystem/Svgs/Tysiav2LedgerFilterInvoices/index'



/** @type {import('Simple/types.js').View} */
export default function Invoice({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Receivables/Content/FilterBy/EntityType/Invoice"
  
}) {
let tabSelectedLedgerReceivablesFilterByValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.ledger.receivables.filter_by',
})
let constantData = 'INVOICE'
let aggregateData = fromAggregate.includes(tabSelectedLedgerReceivablesFilterByValueData, constantData)
let onClick = fromHelpers.useOnFilterClickInvoices({
  children,
  viewPath
  
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let receivablesValueData = fromData.useDataValue({ viewPath,
context: 'receivables',
})
let constantData1 = 'INVOICE'
let aggregateData1 = fromHelpers.getCount(receivablesValueData, constantData1)
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 onClick={onClick}
 type={aggregateData ? "primary" : "secondary"}
 data="tab.selected.ledger.receivables.filter_by"
 data="'INVOICE'"
 aggregate="/Data/aggregate.js includes"
>
{childProps => (
<React.Fragment>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2LedgerFilterInvoices
{...childProps}
  viewPath={`${viewPath}/Tysiav2LedgerFilterInvoices`}
 fill="white"
 width={16}
 height={16}
/>
)}
</TysiaButtonIcon>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Invoices"
/>
<TysiaTag
{...childProps}
  viewPath={`${viewPath}/TysiaTag`}
 alignSelf="center"
 type="grey"
 style="filled"
 size="small"
 marginLeft={dtSpaceXxs}
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="receivables"
 data="'INVOICE'"
 aggregate="helpers.js getCount"
 text={aggregateData1}
/>
)}
</TysiaTag>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}